import BaseService from '../../base/base_service';
import IOrbitComponentRenderService from './orbit_component_render_service_interface';
import {
    IGermanyResponsibleGamingButtonOptions,
    IOrbitComponentInSdk,
    IOrbitComponentToSdkAdapterService, IOrbitDialogInSdk
} from '../../../../common/interfaces/orbit-component-to-sdk-adapter/orbit-component-to-sdk-adapter.service.interface';
import {
    ITimeSpentReminderWithBalanceComponentProps,
    ITimeSpentReminderOptions
} from '../../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/time-spent-reminder-options';
import {IStatePopupDisplayParams} from "../../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/state-popup-display-params";
import {IdleRecommendationsComponentProps} from "../../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/idle-recommendations.component-props";
import Event from "../../utils/event";
import {SYSTEM_EVENTS} from "../../events/events";
import {IGeoPermissionPopupOptions} from "../../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/geo-permission-popup.component-props";
import {
    IIntrusiveMessagePopupDisplayParams
} from "../../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/intrusive-message-popup-display-params";
import {
    ITempAccountShowPopupOptions
} from "../../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/temp-account-popup-params";
import {ILoginToastDef} from '../../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/login-toast.component-props';

interface OrbitComponentRendererServiceParams {
    getOrbitComponentToSdkAdapter: () => IOrbitComponentToSdkAdapterService;
}

export default class OrbitComponentRenderService extends BaseService implements IOrbitComponentRenderService {
    static CLASS = 'OrbitComponentRenderService';

    init(params: OrbitComponentRendererServiceParams) {
        super.init(params);
        this._getOrbitComponentToSdkAdapter = params.getOrbitComponentToSdkAdapter;
    }

    private _getOrbitComponentToSdkAdapter: () => IOrbitComponentToSdkAdapterService;

    renderGermanyResponsibleGamingButtons(element: HTMLElement, options?:IGermanyResponsibleGamingButtonOptions): IOrbitComponentInSdk{
        return this._getOrbitComponentToSdkAdapter().renderGermanyResponsibleGamingButtons(element, options);
    }

    showLocationPopup(props: IStatePopupDisplayParams) {
        Event.fire(SYSTEM_EVENTS.LOCATION_POPUP_OPEN);
        return this._getOrbitComponentToSdkAdapter().showLocationPopup(props);
    }

    showGeoPermissionPopup(props: IGeoPermissionPopupOptions) {
        return this._getOrbitComponentToSdkAdapter().showGeoPermissionPopup(props);
    }




    showTimeSpentReminderWithDropdown(options: ITimeSpentReminderOptions): IOrbitDialogInSdk {
        return this._getOrbitComponentToSdkAdapter().showTimeSpentReminderWithDropdown(options);
    }

    showTimeSpentReminderWithBalance(options: ITimeSpentReminderWithBalanceComponentProps): IOrbitDialogInSdk {
        return this._getOrbitComponentToSdkAdapter().showTimeSpentReminderWithBalance(options);
    }


    showIntrusiveMessagePopup(params: IIntrusiveMessagePopupDisplayParams): IOrbitDialogInSdk {
        return this._getOrbitComponentToSdkAdapter().showIntrusiveMessagePopup(params);
    }

    showDisconnectPopup(): IOrbitDialogInSdk {
        return this._getOrbitComponentToSdkAdapter().showDisconnectPopup();
    }

    renderIdleRecommendations(element: HTMLElement, options: IdleRecommendationsComponentProps): IOrbitComponentInSdk {
        return this._getOrbitComponentToSdkAdapter().renderIdleRecommendations(element, options);
    }

    showAboutDialog(): Promise<void> {
        return this._getOrbitComponentToSdkAdapter().showAboutDialog();
    }

    showTempAccountPopup(options: ITempAccountShowPopupOptions): IOrbitDialogInSdk {
        return this._getOrbitComponentToSdkAdapter().showTempAccountPopup(options);
    }

    showInitBiometricDialog(): IOrbitDialogInSdk {
        return this._getOrbitComponentToSdkAdapter().showInitBiometricDialog();
    }

    showDefaultKickPopup(popupTextKey: string): IOrbitDialogInSdk {
        return this._getOrbitComponentToSdkAdapter().showDefaultKickPopup(popupTextKey);
    }

    showLoginMessageToast(props: ILoginToastDef): void {
        return this._getOrbitComponentToSdkAdapter().showLoginMessageToast(props);
    }
}